import React from 'react'; 
import { graphql} from 'gatsby';
import { GatsbyImage} from "gatsby-plugin-image"
import styled from 'styled-components';
import { DiscussionEmbed } from 'disqus-react';

import Layout from "../components/layout";
import Seo from '../components/seo';
import Bio from '../components/bio';
import RelatedPost from '../components/relatedPost';




const StyledPostContainer = styled.article`
 max-width: 720px;
    margin: 0 auto;
    padding: 6vw 0 0;
    @media (max-width: 850px){
    padding: 6vw;
}
`;


const StyledPostHeader = styled.header`
  margin-bottom: 50px;
  text-align: center;
  h1{
  font-family: var(--title-font);
  font-size: 45px;
  line-height: 1.4;
  letter-spacing: 5px;
    text-transform: uppercase;
    font-weight: 900;
    
    @media (max-width: 500px){
    	font-size: 27px;
	}
    
  }
  .tag {
  	text-transform: uppercase;
  	font-size: 14px;
  	font-weight: 500;
    margin-right: 10px;
    margin-bottom: 15px;
    letter-spacing: 3px;
  }
`;

const StyledContentImage = styled.div`
position: relative;
    width: 75vw;
    min-width: 100%;
    margin: 4vw calc(50% - 50vw);
    -webkit-transform: translateX(calc(50vw - 50%));
    transform: translateX(calc(50vw - 50%));

`;
const BlogPostComment = styled.div`
	margin-top:10px;
`;
const StyledPostContent = styled.div`
    font-size: 19px;
    font-weight: 400;
    max-width: 700px;
    margin: 0 auto 8vh;
    padding: 0 1vw;
    h4 {
    font-size: 24px;
    margin-top: 50px;
}
    p {
    line-height: 1.65;
    position: relative;
    margin-right: 0;
    margin-left: 0;
	}
	p:first-child {
    margin-top: 0;
}
@media (max-width: 850px){
    font-size: 16px;
}
`

const RelatedPostWrapper =styled.div`
margin: 0 auto;
  @media (max-width: 575px) {
    padding: 0 15px;
  }
  .pagination {
    margin-top: 80px;
    @media (max-width: 1024px) {
      margin-top: 60px;
    }
    @media (max-width: 575px) {
      margin-top: 30px;
    }
  }
`



const BlogPostTemplate = ({ location, pageContext, data }) => {

  	const { edges } = data.allMarkdownRemark;
	const postNode = data.markdownRemark;
  	const post = postNode.frontmatter;
  	const title = post.title;
  	const date= post.date;
  	const description = postNode.excerpt;
  	
  	const siteUrl = data.site.siteMetadata.siteUrl;
  	
  	const authorsName = (post["author"] !== null) ? post.author.name : "unknown author";
  	const imagelocation = (post["cover"] !== null) ? (`${siteUrl + post.cover.seo.gatsbyImageData.images.fallback.src}`) : "";
  	const tags = post.tags
	
	const disqusConfig = {
    	shortname: process.env.GATSBY_DISQUS_NAME,
    	config: { identifier: location.href, title },
  	};
  	
  	return(
  		<Layout location={location}>
  			 <Seo 
  			 title={title}
  			 date={date}
  			 authorName={authorsName}
  			 tgas={tags}
  			 description={description}
  			 image={imagelocation}
  			 location={location}/>
             
             <StyledPostContainer>
             	<StyledPostHeader>
                	<p className="tag">{post.tags[0]}</p>
					<h1>{post.title}</h1>
        		</StyledPostHeader>
        
        		{post.cover && (
    				<StyledContentImage>
      					<GatsbyImage image={post.cover.regular.gatsbyImageData} 
      								 alt={title}/>
     				</StyledContentImage>
    			)}

			<StyledPostContent>
            	<div dangerouslySetInnerHTML={{ __html: postNode.html }}/>
                
                {post.author && (<Bio author={post.author}/>)}
          
          		 <BlogPostComment>
          			<DiscussionEmbed {...disqusConfig} />
        		</BlogPostComment>
       		</StyledPostContent>
       
		</StyledPostContainer>
              
              
        <RelatedPostWrapper>
          <RelatedPost posts={edges} title="Related Posts"/>
       </RelatedPostWrapper>  
	
	</Layout>
  	
  	);
};

export default BlogPostTemplate;


export const pageQuery = graphql`
  query BlogPost($slug: String!,$tag: [String!]) {
  site {
      siteMetadata {
        siteUrl
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      excerpt
      frontmatter {
        title
        date(formatString: "DD MMM, YYYY")
        description
        tags
        author {
          id
          name
          bio
          avatar{
          childImageSharp {
        	gatsbyImageData(width: 140, height:140,layout: FIXED)
      	}
          }
          social{
          	url
          }
        }
        cover{
        	regular:childImageSharp {
                gatsbyImageData(layout: CONSTRAINED)
         	}
         	seo:childImageSharp {
                gatsbyImageData(width: 600, height:330,layout: FIXED,formats: [JPG])
         	}
         }
      }
      fields {
        slug
      }
    }
    allMarkdownRemark(
    limit: 3
    sort: { fields: [frontmatter___date], order: DESC }
    filter: {
        frontmatter: { tags: { in: $tag } }
        fields: { slug: { ne: $slug } }
      })
     {
        totalCount
        edges {
          node {
            excerpt(pruneLength: 120)
            fields {
              slug
             }
            frontmatter {
              date(formatString: "MMM DD, YYYY")
              title
              description
              tags
              cover {
                childImageSharp {
                gatsbyImageData(width:500, height:300, layout: CONSTRAINED)
         		
              }
              }
            }
          }
        }
      }
  }
`;
